var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandeiraBrasil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V34H50V0Z",
    fill: "#007024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27222 17.0921L25.1305 4.2207L45.9887 17.0921L25.1305 29.9636L4.27222 17.0921Z",
    fill: "#F7C600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1305 25.5938C29.9882 25.5938 33.9261 21.7882 33.9261 17.0938C33.9261 12.3993 29.9882 8.59375 25.1305 8.59375C20.2728 8.59375 16.3348 12.3993 16.3348 17.0938C16.3348 21.7882 20.2728 25.5938 25.1305 25.5938Z",
    fill: "#212A74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6165 14.9581C16.736 14.5127 16.8928 14.0774 17.0853 13.6564C20.0575 13.2464 23.0858 13.4464 25.9726 14.2435C28.8594 15.0406 31.54 16.4168 33.8394 18.2824C33.7727 18.7381 33.6678 19.1877 33.5258 19.627C31.2576 17.6615 28.5568 16.2199 25.6274 15.411C22.6981 14.6022 19.6168 14.4473 16.6165 14.9581Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.632 14.0938L27.5585 14.3207L27.751 14.1804H27.513L27.7056 14.3207L27.632 14.0938Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8514 15.1602L17.7778 15.3871L17.9704 15.2468H17.7324L17.9249 15.3871L17.8514 15.1602Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7652 17.1289L21.7096 17.3005L21.8552 17.1944H21.6752L21.8208 17.3005L21.7652 17.1289Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3246 16.3711L27.2866 16.4885L27.3862 16.4159H27.2631L27.3627 16.4885L27.3246 16.3711Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5638 19.0293L18.4902 19.2562L18.6828 19.116H18.4448L18.6373 19.2562L18.5638 19.0293Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4805 19.8652L17.4249 20.0368L17.5705 19.9308H17.3905L17.5361 20.0368L17.4805 19.8652Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4172 18.5391L19.4003 18.5912L19.4446 18.559H19.3898L19.4341 18.5912L19.4172 18.5391Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4371 19.9297L20.3815 20.1013L20.5271 19.9952H20.3471L20.4927 20.1013L20.4371 19.9297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 20.9219L20.1622 21.0393L20.2618 20.9667H20.1387L20.2383 21.0393L20.2002 20.9219Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5016 21.793L21.4281 22.0199L21.6207 21.8797H21.3826L21.5752 22.0199L21.5016 21.793Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0019 18.2812L24.9463 18.4528L25.0919 18.3468H24.9119L25.0575 18.4528L25.0019 18.2812Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1581 19.2715L24.1201 19.3889L24.2197 19.3163H24.0966L24.1962 19.3889L24.1581 19.2715Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6418 19.8379L24.6249 19.8901L24.6692 19.8578H24.6144L24.6587 19.8901L24.6418 19.8379Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0198 20.9922L24.9463 21.2191L25.1389 21.0789H24.9008L25.0934 21.2191L25.0198 20.9922Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9959 19.1289L25.9403 19.3005L26.0859 19.1944H25.9059L26.0515 19.3005L25.9959 19.1289Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1766 19.9785L31.103 20.2055L31.2956 20.0652H31.0576L31.2501 20.2055L31.1766 19.9785Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 20.1191L32.4464 20.2365L32.546 20.164H32.4229L32.5225 20.2365L32.4844 20.1191Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5108 20.9336L31.4552 21.1052L31.6008 20.9991H31.4208L31.5664 21.1052L31.5108 20.9336Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9919 21.625L30.9363 21.7966L31.0819 21.6905H30.9019L31.0475 21.7966L30.9919 21.625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2712 22.1094L30.2331 22.2268L30.3327 22.1542H30.2096L30.3092 22.2268L30.2712 22.1094Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4181 22.0547L29.3801 22.1721L29.4797 22.0995H29.3566L29.4562 22.1721L29.4181 22.0547Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4174 22.9043L29.3618 23.0759L29.5074 22.9698H29.3275L29.4731 23.0759L29.4174 22.9043Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4268 23.7871L29.3888 23.9045L29.4884 23.832H29.3652L29.4649 23.9045L29.4268 23.7871Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3976 22.2207L28.3596 22.3381L28.4592 22.2655H28.3361L28.4357 22.3381L28.3976 22.2207Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5221 23.0293L27.499 23.0983L27.5594 23.0557H27.4847L27.5452 23.0983L27.5221 23.0293Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9289 22L26.8908 22.1174L26.9904 22.0448H26.8673L26.9669 22.1174L26.9289 22Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2185 24.0137L25.1924 24.0939L25.2606 24.0443H25.1764L25.2445 24.0939L25.2185 24.0137Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandeiraBrasil);
export default __webpack_public_path__ + "static/media/Bandeira-Brasil.8013f8be101a15dee39001c37681fd2c.svg";
export { ForwardRef as ReactComponent };